import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import DeleteConfirmation from "../deleteConfirmation";
import Table from "../Theme/Table.js";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Edit from "./Edit";
import Badge from "@mui/material/Badge";
import Spinner from "../Spinner";
import { useContext } from "react";
import { RoleContext } from "../RoleContext";
import TableOne from "./Table";
import { Button, Input } from "antd";
import { Container, Row, Col, Card, Form, Badge as BootstrapBadge } from "react-bootstrap";
import { Search, Close, CheckCircle, People } from "@mui/icons-material";
const PassengersList = ({
  handleSelectRows,
  setShowTable,
  selectedPassengers,
}) => {
  const roleData = useContext(RoleContext);
  var role = JSON.parse(roleData);
  const [passengers, setPassengers] = useState([]);
  const [searchData, setSearchedData] = useState([]);

  const [id, setId] = useState(null);
  const [data, setData] = useState(null);
  let [loading, setLoading] = useState(true);
  const getPassengers = async () => {
    const response = await axios
      .get("passengers/")
      .then((res) => {
        setPassengers(res.data);
        setLoading(false);
        // notify()
      })
      .catch((err) => {
        notifyError();
      });
  };

  const hideConfirmationModal = () => {
    setDisplayConfirmationModal(false);
  };

  const [deleteMessage, setDeleteMessage] = useState(null);
  const [displayAddModal, setDisplayAddModal] = useState(false);
  const [displayConfirmationModal, setDisplayConfirmationModal] =
    useState(false);

  const [searchText, setSearchText] = useState("");

  const showDeleteModal = (id, name) => {
    setId(id);
    setDeleteMessage(`Are you sure you want to delete this passenger`);
    setDisplayConfirmationModal(true);
  };

  const hideAddModal = () => {
    setDisplayAddModal(false);
  };
  const submitDelete = (id) => {
    console.log(id);
    deletePassenger(id);
    setDisplayConfirmationModal(false);
    // getPassengers();
  };
  const deletePassenger = async (id) => {
    const response = await axios.delete("/passenger/" + id, {
      data: { id: id },
    });
    getPassengers();
  };

  const showEditModal = (id) => {
    setId(id);

    axios.get("/passenger/" + id, {}).then((res) => {
      setData(res.data.passenger);

      setDisplayEditModal(true);
    });
  };
  const [displayEditModal, setDisplayEditModal] = useState(false);

  // Hide add modal
  const hideEditModal = () => {
    setDisplayEditModal(false);
  };

  const edit = "passenger";
  const detail = "viewPassenger";

  const notify = () =>
    toast.success("Passengers list loaded.", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: Math.floor(Math.random() * 1000000000000 + 1),
    });

  const notifyError = () =>
    toast.error("Something went wrong ...", {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      toastId: Math.floor(Math.random() * 1000000000000 + 1),
    });
  useEffect(() => {
    getPassengers();
  }, []);

  const handleSearch = (value) => {
    setSearchText(value);
  };

  // Filter the data based on the search text
  useEffect(() => {
    if (searchText) {
      const filteredData = passengers.filter((record) =>
        Object.values(record).some(
          (value) =>
            value &&
            value.toString().toLowerCase().includes(searchText.toLowerCase()) // Check if the value is truthy before calling toString
        )
      );
      setSearchedData(filteredData);
    } else {
      setSearchedData(passengers);
    }
  }, [searchText, passengers]); // Also add 'passengers' to the dependency array

  const column = [
    {
      title: "Id",
      dataIndex: "id",
    },
    {
      title: "First Name",
      dataIndex: "firstName",
    },
    {
      title: "Last Name",
      dataIndex: "lastName",
    },

    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
    {
      title: "Gender",
      dataIndex: "gender",
    },

    // {
    // title: "Status",
    // dataIndex: "status",
    // render: (_, { isActive }) => {
    //   const st = isActive;
    //   return (
    //     <div
    //       style={{
    //         border: "1px solid " + (st ? "#10B981" : "#B24D4D"),
    //         color: st ? "#10B981" : "#B24D4D",
    //         backgroundColor: "white",
    //         padding: " 4px 15px",
    //         borderRadius: "3px",
    //         maxWidth: "200px",
    //       }}
    //     >
    //       {isActive ? "Active" : "InActive"}
    //     </div>
    //   );
    // },
    // },
  ];

  const hideTable = () => {
    setShowTable(false);
  };

  return (
    <div className="content-wrappers">
      <br />
      <br />
      <ToastContainer />

      <section className="contents">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="card">
                <div
                  className="card-headers"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    height: "50px",
                    margin: "0px 5px",
                  }}
                >
                  <h3 className="card-title">Select of Passengers</h3>

                  <h3
                    className="card-title"
                    style={{
                      border: "1px solid #807e7e",
                      borderRadius: "7px",
                      padding: "6px 10px",
                      fontFamily: "sans-serif",
                      fontWeight: 500,
                      cursor: "pointer",
                      "&:hover": {
                        background: "black",
                        color: "white",
                      },
                    }}
                    onClick={hideTable}
                  >
                    Close
                  </h3>
                </div>

                <div className="card-body">
                  <Input
                    placeholder="Search passenger"
                    value={searchText}
                    onChange={(e) => handleSearch(e.target.value)}
                    style={{ width: 200, marginBottom: 8, display: "block" }}
                  />

                  {loading && (
                    <div>
                      <Spinner />
                    </div>
                  )}

                  {!loading && (
                    <TableOne
                      loadding={""}
                      columns={column}
                      data={searchData}
                      onSelectRows={handleSelectRows}
                      selectedPassengers={selectedPassengers}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <DeleteConfirmation
        showModal={displayConfirmationModal}
        confirmModal={submitDelete}
        hideModal={hideConfirmationModal}
        id={id}
        message={deleteMessage}
      />
      {displayEditModal == true && (
        <Edit
          id={id}
          data={data}
          showModal={displayEditModal}
          hideModal={hideEditModal}
        />
      )}
    </div>
  );
};
export default PassengersList;
